import styled from "styled-components";
import SearchDefault from "components/Input/Search";
import Loader from "components/Layout/Loader";
import { COLORS } from "constants/colorScheme";

export const PageControl = styled.div`
  :not(:last-child) {
    margin-right: 40px;
  }
`;

export const Search = styled(SearchDefault)`
  width: 300px;
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin-bottom: 30px;
`;

export const OverflowLoader = styled(Loader)`
  position: absolute;
  z-index: 10;

  background-color: ${COLORS.WHITE_40};
`;

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 30px;
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;

export const TriviaCardWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;
